import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import FilesView from 'components/composed/views/FilesView';
import InsightsView from 'components/composed/views/InsightsView';
import StatementsView from 'components/composed/views/StatementsView';

const StyledContainer = styled.div`
  display: grid;
  gap: ${theme.spaces.smallX}px;
  width: 100%;

  > div {
    &:nth-child(1) {
      grid-column-start: 1;
      grid-column-end: 4;
      grid-row-start: 1;
      grid-row-end: 2;
    }

    &:nth-child(2) {
      grid-column-start: 4;
      grid-column-end: 7;
      grid-row-start: 1;
      grid-row-end: 2;
      max-height: 481px;
      width: 360px;
    }

    &:nth-child(3) {
      grid-column-start: 1;
      grid-column-end: 7;
      grid-row-start: 2;
      grid-row-end: 3;
    }
  }

  @media ${theme.devices.tablet} {
    display: block;

    > div {
      margin-bottom: ${theme.spaces.regular}px;

      &:nth-child(2) {
        max-height: unset;
        width: unset;
      }
    }
  }
`;

const BookkeepingOverviewSection = () => {
  return (
    <StyledContainer>
      <InsightsView />
      <FilesView />
      <StatementsView />
    </StyledContainer>
  );
};

export default BookkeepingOverviewSection;
